import { useState, useEffect, useRef } from "react";
import home from "../../../Images/homeLite.jpg";
import tw from "twin.macro";
import styled from "styled-components";
import Typed from "typed.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs";

const TypedString = tw.span``;
const HeroContainer = styled.div`
  ${tw`relative px-4 sm:px-8 max-w-screen-2xl mx-auto`}
  ${() => window.location.href.includes("home-page") && tw`mt-56`}
  ${() => window.location.href.includes("pdf") && tw`mt-48`}`
const Notificationn = tw.span`inline-block my-4 pl-3 py-1 md:mt-48 sm:mt-20 mt-48 text-gray-100 border-blue-800 font-medium text-lg border-l-4 backdrop-blur-sm bg-black/10 pr-3`;
const Notification = tw.span`inline-block my-4 pl-3 py-1  lg:mt-24 md:mt-24 mt-5 text-gray-100 border-blue-800 font-medium  lg:text-lg md:text-lg sm:text-sm border-l-4 backdrop-blur-sm bg-black/10 pr-3`;
const TwoColumn = styled.div((props) => [
  props.containerPdf
    ? tw.div` pb-32 px-16 flex justify-between items-center flex-col lg:flex-row`
    : tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`,
]);
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;
const InsideHeading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Container = styled.div`
  ${tw`relative h-screen bg-cover`}
`;
const HighlightedText = tw.span`bg-gray-100 text-primary-500 px-4 pb-2 inline-block`;
const PrimaryAction = tw.button` px-8  py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 font-bold rounded bg-primary-500 text-gray-100
  hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline
  border-b-0`;

const SliderPage = ({ slidesData, imagehalf }) => {
  const navigate = useNavigate();
  useEffect(() => {
    var typed = new Typed(`#${slidesData.typeID}`, {
      strings: [slidesData.typedHead],
      typeSpeed: 50,
      backSpeed: 50,
      loop: false,
    });
    return () => {
      typed.destroy();
    };
  }, []);

  const condition = window.location.pathname === "/";

  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  return (
    <>
      {imagehalf ? (
        <Container
          style={{
            height: !condition ? "70vh" : "100vh",
            width: "100vw",
          }}
        >
          <div
            style={{
              height: "57vh",
              width: "100vw",
              backgroundImage: ` url(${slidesData.image})`,
              // filter: "brightness(0.7)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          ></div>
          <div
            style={{
              height: "100vh",
              width: "100vw",
              position: "absolute",
              height: "100px",
              zIndex: "1",
              top: 0,
              left: 0,
            }}
          >
            <HeroContainer>
              <TwoColumn>
                <LeftColumn>
                  <Notification>
                    <TypedString id={slidesData.typeID}></TypedString>
                  </Notification>
                  <InsideHeading >
                    <span className="backdrop-blur-sm bg-black/5 pr-3 pb-2">{slidesData.heading1}</span>
                    {slidesData.typeID !== "element4_app" && <br />}
                    <HighlightedText className="transform -skew-x-12">
                      {slidesData.heading2}
                    </HighlightedText>
                  </InsideHeading>
                  {window.location.pathname === "/" && (
                    <PrimaryAction
                      onClick={() =>
                        navigate(slidesData.route, {
                          state: slidesData.routeState,
                        })
                      }
                    >
                      {slidesData.buttonName}
                    </PrimaryAction>
                  )}
                </LeftColumn>
              </TwoColumn>
            </HeroContainer>
          </div>
        </Container>
      ) : (
        <Container
          style={{
            height: "100vh",
            width: "100vw",
          }}
        >
          <div
            style={{
              height: "100vh",
              width: "100vw",
              backgroundImage: `url(${slidesData.image})`,
              // filter: "brightness(0.9)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          ></div>
          {/* //pink background color */}
          {slidesData.image === home && (
            <div
              style={{
                width: `${window.location.href.includes("home-page-pdf")?"100%":"99%"}`,
                height: "100vh",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: "1",
                backgroundColor: "rgba(184, 50, 128, 0.25)",
              }}
            ></div>
          )}
          <div
            style={{
              height: "100vh",
              width: "100vw",
              position: "absolute",
              height: "100px",
              zIndex: "2",
              top: 0,
              left: 0,
            }}
          >
            <HeroContainer>
              <TwoColumn>
                <LeftColumn>
                  <Notificationn>
                    <TypedString id={slidesData.typeID}></TypedString>
                  </Notificationn>
                  <Heading>
                  <span className="backdrop-blur-sm bg-black/5 px-3 pb-2">{slidesData.heading1}</span>
                  {slidesData.typeID !== "e7" && <br />}
                    <HighlightedText className="transform -skew-x-12">
                      {slidesData.heading2}
                    </HighlightedText>
                  </Heading>
                  {window.location.pathname === "/" && (
                    <PrimaryAction
                      onClick={() =>
                        navigate(slidesData.route, {
                          state: slidesData.routeState,
                        })
                      }
                    >
                      {slidesData.buttonName}
                    </PrimaryAction>
                  )}
                </LeftColumn>
              </TwoColumn>
            </HeroContainer>
          </div>
        </Container>
      )}
    </>
  );
};

export default SliderPage;
